const reservoirs = {
  mapped: {
    "Abilene": "abilene.csv",
    "Addicks": "addicks.csv",
    "Alan Henry": "alan-henry.csv",
    "Amistad": "amistad.csv",
    "Amon G Carter": "amon-g-carter.csv",
    "Aquilla": "aquilla.csv",
    "Arlington": "arlington.csv",
    "Arrowhead": "arrowhead.csv",
    "Athens": "athens.csv",
    "Austin": "austin.csv",
    "B A Steinhagen": "b-a-steinhagen.csv",
    "Bardwell": "bardwell.csv",
    "Belton": "belton.csv",
    "Benbrook": "benbrook.csv",
    "Bob Sandlin": "bob-sandlin.csv",
    "Bonham": "bonham.csv",
    "Brady Creek": "brady-creek.csv",
    "Bridgeport": "bridgeport.csv",
    "Brownwood": "brownwood.csv",
    "Buchanan": "buchanan.csv",
    "Caddo": "caddo.csv",
    "Canyon": "canyon.csv",
    "Cedar Creek": "cedar-creek.csv",
    "Champion Creek": "champion-creek.csv",
    "Choke Canyon": "choke-canyon.csv",
    "Cisco": "cisco.csv",
    "Coleman": "coleman.csv",
    "Coleto Creek": "coleto-creek.csv",
    "Colorado City": "colorado-city.csv",
    "Conroe": "conroe.csv",
    "Corpus Christi": "corpus-christi.csv",
    "Crook": "crook.csv",
    "Cypress Springs": "cypress-springs.csv",
    "E V Spence": "e-v-spence.csv",
    "Eagle Mountain": "eagle-mountain.csv",
    "Elephant Butte": "elephant_butte_reservoir.csv",
    "Falcon": "falcon.csv",
    "Fork": "fork.csv",
    "Fort Phantom Hill": "fort-phantom-hill.csv",
    "Georgetown": "georgetown.csv",
    "Graham": "graham.csv",
    "Granbury": "granbury.csv",
    "Granger": "granger.csv",
    "Grapevine": "grapevine.csv",
    "Greenbelt": "greenbelt.csv",
    "Halbert": "halbert.csv",
    "Hords Creek": "hords-creek.csv",
    "Houston County": "houston-county.csv",
    "Houston": "houston.csv",
    "Hubbard Creek": "hubbard-creek.csv",
    "Hubert H Moss": "hubert-h-moss.csv",
    "Inks": "inks.csv",
    "J B Thomas": "j-b-thomas.csv",
    "Jacksonville": "jacksonville.csv",
    "Jim Chapman": "jim-chapman.csv",
    "Joe Pool": "joe-pool.csv",
    "Kemp": "kemp.csv",
    "Kickapoo": "kickapoo.csv",
    "Lake O The Pines": "lake-o-the-pines.csv",
    "Lavon": "lavon.csv",
    "Leon": "leon.csv",
    "Lewisville": "lewisville.csv",
    "Limestone": "limestone.csv",
    "Livingston": "livingston.csv",
    "Lost Creek": "OR_Lost_Creek.csv",
    "Lyndon B Johnson": "lyndon-b-johnson.csv",
    "Mackenzie": "mackenzie.csv",
    "Martin": "martin.csv",
    "Medina": "medina.csv",
    "Meredith": "meredith.csv",
    "Millers Creek": "millers-creek.csv",
    "Mineral Wells": "mineral-wells.csv",
    "Monticello": "monticello.csv",
    "Mountain Creek": "mountain-creek.csv",
    "Murvaul": "murvaul.csv",
    "Nacogdoches": "nacogdoches.csv",
    "Natural Dam": "natural-dam.csv",
    "Navarro Mills": "navarro-mills.csv",
    "New Terrell City": "new-terrell-city.csv",
    "Nocona": "nocona.csv",
    "North Fork Buffalo Creek": "north-fork-buffalo-creek.csv",
    "O C Fisher": "o-c-fisher.csv",
    "O H Ivie": "o-h-ivie.csv",
    "Oak Creek": "oak-creek.csv",
    "Palestine": "palestine.csv",
    "Palo Duro": "palo-duro.csv",
    "Palo Pinto": "palo-pinto.csv",
    "Pat Cleburne": "pat-cleburne.csv",
    "Pat Mayse": "pat-mayse.csv",
    "Possum Kingdom": "possum-kingdom.csv",
    "Proctor": "proctor.csv",
    "Ray Hubbard": "ray-hubbard.csv",
    "Ray Roberts": "ray-roberts.csv",
    "Red Bluff": "red-bluff.csv",
    "Richland Chambers": "richland-chambers.csv",
    "Sam Rayburn": "sam-rayburn.csv",
    "Somerville": "somerville.csv",
    "Squaw Creek": "squaw-creek.csv",
    "Stamford": "stamford.csv",
    "Stillhouse Hollow": "stillhouse-hollow.csv",
    "Sulphur Springs": "sulphur-springs.csv",
    "Sweetwater": "sweetwater.csv",
    "Tawakoni": "tawakoni.csv",
    "Texana": "texana.csv",
    "Texoma": "texoma.csv",
    "Toledo Bend": "toledo-bend.csv",
    "Travis": "travis.csv",
    "Twin Buttes": "twin-buttes.csv",
    "Tyler": "tyler.csv",
    "Waco": "waco.csv",
    "Waxahachie": "waxahachie.csv",
    "Weatherford": "weatherford.csv",
    "White River": "white-river.csv",
    "Whitney": "whitney.csv",
    "Worth": "worth.csv",
    "Wright Patman": "wright-patman.csv",
    "Alpine Lake": "alpine_lake_.csv",
    "Antelope Lake": "antelope_lake_.csv",
    "Barrett": "barrett_.csv",
    "Bear River At Camp Far West Dam": "bear_river_at_camp_far_west_dam_.csv",
    "Bear Valley Dam": "bear_valley_dam_.csv",
    "Beardsley Lake": "beardsley_lake_.csv",
    "Berryessa": "berryessa_.csv",
    "Black Butte": "black_butte_.csv",
    "Boca Reservoir": "boca_reservoir_.csv",
    "Bouquet Canyon": "bouquet_canyon_.csv",
    "Bowman Lake": "bowman_lake_.csv",
    "Bridgeport Reservoir": "bridgeport_reservoir_.csv",
    "Briones Dam": "briones_dam_.csv",
    "Buchanan Dam": "buchanan_dam_.csv",
    "Bucks Lake Storage": "bucks_lake_storage_.csv",
    "Butt Valley": "butt_valley_.csv",
    "Cachuma Lake": "cachuma_lake_.csv",
    "Calaveras": "calaveras_.csv",
    "Camanche Reservoir": "camanche_reservoir_.csv",
    "Caples Lake": "caples_lake_.csv",
    "Casitas": "casitas_.csv",
    "Castaic": "castaic_.csv",
    "Chabot": "chabot_.csv",
    "Cherry Lake": "cherry_lake_.csv",
    "Clear Lk - Cache Creek": "clear_lk_-_cache_creek_.csv",
    "Clear Lk - Klamath R": "clear_lk_-_klamath_r_.csv",
    "Cogswell Reservoir": "cogswell_reservoir_.csv",
    "Courtright": "courtright_.csv",
    "Coyote Res-sta Clara": "coyote_res-sta_clara_.csv",
    "Crane Valley": "crane_valley_.csv",
    "Cuyamaca Dam": "cuyamaca_dam_.csv",
    "Del Valle": "del_valle_.csv",
    "Diamond Valley": "diamond_valley_.csv",
    "Don Pedro Reservoir": "don_pedro_reservoir_.csv",
    "Donnells": "donnells_.csv",
    "Dwinnell": "dwinnell_.csv",
    "East Park Reservoir": "east_park_reservoir_.csv",
    "El Capitan Dam": "el_capitan_dam_.csv",
    "Englebright": "englebright_.csv",
    "Florence Lake": "florence_lake_.csv",
    "Folsom Lake": "folsom_lake_.csv",
    "French Lake": "french_lake_.csv",
    "French Meadows": "french_meadows_.csv",
    "Frenchman Dam": "frenchman_dam_.csv",
    "Friant Dam": "friant_dam_.csv",
    "Gem  Lake": "gem_lake_.csv",
    "Gerber": "gerber_.csv",
    "Gibraltar Dam": "gibraltar_dam_.csv",
    "Grant Lake": "grant_lake_.csv",
    "Haiwee": "haiwee_.csv",
    "Hell Hole": "hell_hole_.csv",
    "Henshaw": "henshaw_.csv",
    "Hetch Hetchy": "hetch_hetchy_.csv",
    "Hidden Dam": "hidden_dam_.csv",
    "Huntington Lake": "huntington_lake_.csv",
    "Ice House": "ice_house_.csv",
    "Indian Valley": "indian_valley_.csv",
    "Iron Canyon": "iron_canyon_.csv",
    "Isabella Dam": "isabella_dam_.csv",
    "Jenkinson Lake": "jenkinson_lake_.csv",
    "Kent": "kent_.csv",
    "Keswick Reservoir": "keswick_reservoir_.csv",
    "Lake Almanor": "lake_almanor_.csv",
    "Lake Britton": "lake_britton_.csv",
    "Lake Crowley": "lake_crowley_.csv",
    "Lake Davis": "lake_davis_.csv",
    "Lake Eleanor": "lake_eleanor_.csv",
    "Lake Hemet": "lake_hemet_.csv",
    "Lake Hennessey": "lake_hennessey_.csv",
    "Lake Hodges": "lake_hodges_.csv",
    "Lake Jennings": "lake_jennings_.csv",
    "Lake Mathews": "lake_mathews_.csv",
    "Lake Mccloud": "lake_mccloud_.csv",
    "Lake Mcclure": "lake_mcclure_.csv",
    "Lake Mendocino": "lake_mendocino_.csv",
    "Lake Natoma": "lake_natoma_.csv",
    "Lake Pillsbury": "lake_pillsbury_.csv",
    "Lake Piru": "lake_piru_.csv",
    "Lake San Antonio": "lake_san_antonio_.csv",
    "Lake Silverwood": "lake_silverwood_.csv",
    "Lake Spaulding S Yuba System": "lake_spaulding_s_yuba_system_.csv",
    "Lake Tahoe": "lake_tahoe_.csv",
    "Leroy Anderson": "leroy_anderson_.csv",
    "Lewiston": "lewiston_.csv",
    "Lexington Reservoir": "lexington_reservoir_.csv",
    "Little Grass Valley": "little_grass_valley_.csv",
    "Loon Lake": "loon_lake_.csv",
    "Los Banos": "los_banos_.csv",
    "Los Vaqueros Reservoir": "los_vaqueros_reservoir_.csv",
    "Loveland Reservoir": "loveland_reservoir_.csv",
    "Lower Bear": "lower_bear_.csv",
    "Lower Crystal Springs Reservoir": "lower_crystal_springs_reservoir_.csv",
    "Lower Otay": "lower_otay_.csv",
    "Mammoth Pool": "mammoth_pool_.csv",
    "Matilija Dam": "matilija_dam_.csv",
    "Miramar": "miramar_.csv",
    "Modesto Reservoir": "modesto_reservoir_.csv",
    "Morena Dam": "morena_dam_.csv",
    "Mountain Meadows": "mountain_meadows_.csv",
    "Murray Res": "murray_res_.csv",
    "Nacimiento": "nacimiento_.csv",
    "New Bullards Bar": "new_bullards_bar_.csv",
    "New Hogan Lake": "new_hogan_lake_.csv",
    "New Melones Reservoir": "new_melones_reservoir_.csv",
    "Nicasio": "nicasio_.csv",
    "Oneill Forebay": "oneill_forebay_.csv",
    "Oroville Dam": "oroville_dam_.csv",
    "Pardee": "pardee_.csv",
    "Perris": "perris_.csv",
    "Pine Flat Dam": "pine_flat_dam_.csv",
    "Prosser Creek Reservoir": "prosser_creek_reservoir_.csv",
    "Pyramid": "pyramid_.csv",
    "Railroad Canyon": "railroad_canyon_.csv",
    "Redinger Lake": "redinger_lake_.csv",
    "Relief": "relief_.csv",
    "Rollins": "rollins_.csv",
    "Saddlebag Lake Reservoir": "saddlebag_lake_reservoir_.csv",
    "Salt Springs": "salt_springs_.csv",
    "San Andreas": "san_andreas_.csv",
    "San Antonio Reservoir": "san_antonio_reservoir_.csv",
    "San Gabriel": "san_gabriel_.csv",
    "San Luis Reservoir": "san_luis_reservoir_.csv",
    "San Pablo": "san_pablo_.csv",
    "San Vicente": "san_vicente_.csv",
    "Santa Margarita Lake": "santa_margarita_lake_.csv",
    "Santiago Creek Res": "santiago_creek_res_.csv",
    "Scotts Flat": "scotts_flat_.csv",
    "Shasta Dam": "shasta_dam_.csv",
    "Shaver Lake": "shaver_lake_.csv",
    "Skinner": "skinner_.csv",
    "Slab Creek": "slab_creek_.csv",
    "Sly Creek": "sly_creek_.csv",
    "Soulajule Dam": "soulajule_dam_.csv",
    "South Lake": "south_lake_.csv",
    "Spicer Meadows": "spicer_meadows_.csv",
    "Stampede": "stampede_.csv",
    "Stony Gorge Reservoir": "stony_gorge_reservoir_.csv",
    "Strawberry": "strawberry_reservoir.csv",
    "Success Dam": "success_dam_.csv",
    "Sutherland Reservoir": "sutherland_reservoir_.csv",
    "Sweetwater Reservoir": "sweetwater_reservoir_.csv",
    "Terminus Dam": "terminus_dam_.csv",
    "Thermalito  Total": "thermalito_total_.csv",
    "Thomas A Edison": "thomas_a_edison_.csv",
    "Tinemaha Reservoir": "tinemaha_reservoir_.csv",
    "Trinity Lake": "trinity_lake_.csv",
    "Tulloch": "tulloch_.csv",
    "Turlock Lake": "turlock_lake_.csv",
    "Twitchell": "twitchell_.csv",
    "U San Leandro": "u_san_leandro_.csv",
    "Union Valley": "union_valley_.csv",
    "Upper Klamath": "upper_klamath_.csv",
    "Vail Lake": "vail_lake_.csv",
    "Warm Springs": "warm_springs_.csv",
    "Whale Rock": "whale_rock_.csv",
    "Whiskeytown Dam": "whiskeytown_dam_.csv",
    "Wishon": "wishon_.csv",
    "Big Sandy": "big_sandy_reservoir.csv",
    "Blue Mesa": "blue_mesa_reservoir.csv",
    "Caballo": "caballo_reservoir.csv",
    "Causey": "causey_reservoir.csv",
    "Crystal": "crystal_reservoir.csv",
    "Currant Creek": "currant_creek_reservoir.csv",
    "Deer Creek": "deer_creek_reservoir.csv",
    "East Canyon": "east_canyon_reservoir.csv",
    "Echo": "echo_reservoir.csv",
    "Flaming Gorge": "flaming_gorge_reservoir.csv",
    "Fontenelle": "fontenelle_reservoir.csv",
    "Fruitgrowers": "fruitgrowers_reservoir.csv",
    "Huntington North": "huntington_north_reservoir.csv",
    "Hyrum": "hyrum_reservoir.csv",
    "Jackson Gulch": "jackson_gulch_reservoir.csv",
    "Joes Valley": "joes_valley_reservoir.csv",
    "Jordanelle": "jordanelle_reservoir.csv",
    "Lake Powell": "lake_powell.csv",
    "Lake Sumner": "lake_sumner_reservoir.csv",
    "Lemon": "lemon_reservoir.csv",
    "Lost Creek Reservoir": "lost_creek_reservoir.csv",
    "McPhee": "mcphee_reservoir.csv",
    "Meeks Cabin": "meeks_cabin_reservoir.csv",
    "Moon Lake": "moon_lake_reservoir.csv",
    "Morrow Point": "morrow_point_reservoir.csv",
    "Navajo": "navajo_reservoir.csv",
    "Newton": "newton_reservoir.csv",
    "Paonia": "paonia_reservoir.csv",
    "Pineview": "pineview_reservoir.csv",
    "Red Fleet": "red_fleet_reservoir.csv",
    "Ridgway": "ridgway_reservoir.csv",
    "Rifle Gap": "rifle_gap_reservoir.csv",
    "Rockport": "rockport_reservoir.csv",
    "Santa Rosa": "santa_rosa_reservoir.csv",
    "Scofield": "scofield_reservoir.csv",
    "Silver Jack": "silver_jack_reservoir.csv",
    "Starvation": "starvation_reservoir.csv",
    "Stateline": "stateline_reservoir.csv",
    "Steinaker": "steinaker_reservoir.csv",
    "Taylor Park": "taylor_park_reservoir.csv",
    "Upper Stillwater": "upper_stillwater_reservoir.csv",
    "Vallecito": "vallecito_reservoir.csv",
    "Vega": "vega_reservoir.csv",
    "Lake Havasu": "lake_havasu_.csv",
    "Lake Mead": "lake_mead_.csv",
    "Lake Mohave": "lake_mohave_.csv",
    "Agate": "AGA.csv",
    "American Falls": "AMF.csv",
    "Anderson Ranch": "AND.csv",
    "Arrowrock": "ARK.csv",
    "Beulah": "BEU.csv",
    "Banks Lake": "BNK.csv",
    "Bully Creek": "BUL.csv",
    "Cold Springs": "CLS.csv",
    "Crane Prairie": "CRA.csv",
    "Crescent Lake": "CRE.csv",
    "Lake Cascade": "CSC.csv",
    "Deadwood": "DED.csv",
    "Drews": "DRW.csv",
    "Emigrant Lake": "EMI.csv",
    "Black Canyon": "EMM.csv",
    "Fish Lake": "FIS.csv",
    "Fourmile Lake": "FOR.csv",
    "Grand Coulee\/FDR Lake": "GCL.csv",
    "Grassy Lake": "GRS.csv",
    "Haystack": "HAY.csv",
    "Henrys Lake": "HEN.csv",
    "Howard Prairie Lake": "HPD.csv",
    "Hyatt": "HYA.csv",
    "Island Park": "ISL.csv",
    "Jackson Lake": "JCK.csv",
    "Lake Lowell": "LOW.csv",
    "Lucky Peak Lake": "LUC.csv",
    "Mann Creek": "MAN.csv",
    "McKay": "MCK.csv",
    "Milner": "MIL.csv",
    "Lake Walcott": "MIN.csv",
    "Ochoco": "OCH.csv",
    "Lake Owyhee": "OWY.csv",
    "Palisades": "PAL.csv",
    "Phillips Lake": "PHL.csv",
    "Prineville": "PRV.csv",
    "Ririe Lake": "RIR.csv",
    "Reservoir A": "RSA.csv",
    "Henry Hagg Lake": "SCO.csv",
    "Soldiers Meadow": "SOL.csv",
    "Thief Valley": "THF.csv",
    "Unity": "UNY.csv",
    "Warm Springs Reservoir": "WAR.csv",
    "Clear Lake": "OR_Clear_Lake.csv",
    "Wickiup": "WIC.csv",
    "Wildhorse": "WLD.csv",
    "Little Wood": "WOD.csv",
    "Bartlett": "bartlett.csv",
    "C. C. Cragin": "c.c.cragin.csv",
    "Horseshoe": "horseshoe.csv",
    "Lyman Lake": "lymanlake.csv",
    "San Carlos": "sancarlos.csv",
    "Horse Mesa": "horse_mesa.csv",
    "Mormon Flat": "mormon_flat.csv",
    "Roosevelt": "roosevelt.csv",
    "Stewart Mtn": "stewart_mtn.csv",
    "Adobe Creek": "CO_Adobe_Creek.csv",
    "Antero": "CO_Antero.csv",
    "Barr Lake": "CO_Barr_Lake.csv",
    "Boyd Lake": "CO_Boyd_Lake.csv",
    "Carter Lake": "CO_Carter_Lake.csv",
    "Cheesman": "CO_Cheesman.csv",
    "Clear Creek": "CO_Clear_Creek.csv",
    "Cobb Lake": "CO_Cobb_Lake.csv",
    "Continental": "CO_Continental.csv",
    "Crawford": "CO_Crawford.csv",
    "Cucharas": "CO_Cucharas.csv",
    "Dillon": "CO_Dillon.csv",
    "Eleven Mile": "CO_Eleven_Mile.csv",
    "Empire": "CO_Empire.csv",
    "Fossil Creek": "CO_Fossil_Creek.csv",
    "Green Mtn": "CO_Green_Mtn.csv",
    "Gross": "CO_Gross.csv",
    "Groundhog": "CO_Groundhog.csv",
    "Homestake": "CO_Homestake.csv",
    "Horse Creek": "CO_Horse_Creek.csv",
    "Horsecreek": "CO_Horsecreek.csv",
    "Horsetooth": "CO_Horsetooth.csv",
    "Jackson Gulch Reservoir": "CO_Jackson_Gulch_Reservoir.csv",
    "Jackson Lk": "CO_Jackson_Lk.csv",
    "John Martin": "CO_John_Martin.csv",
    "Julesberg": "CO_Julesberg.csv",
    "Lake Granby": "CO_Lake_Granby.csv",
    "Lake Loveland": "CO_Lake_Loveland.csv",
    "Marshall": "CO_Marshall.csv",
    "Marston": "CO_Marston.csv",
    "Meredith Reservoir": "CO_Meredith_Reservoir.csv",
    "Milton": "CO_Milton.csv",
    "Mountain Home": "CO_Mountain_Home.csv",
    "Narraguinnep": "CO_Narraguinnep.csv",
    "Platoro": "CO_Platoro.csv",
    "Point of Rocks": "CO_Point_of_Rocks.csv",
    "Prewitt": "CO_Prewitt.csv",
    "Pueblo": "CO_Pueblo.csv",
    "Ralph Price": "CO_Ralph_Price.csv",
    "Rio Grande": "CO_Rio_Grande.csv",
    "Riverside": "CO_Riverside.csv",
    "Ruedi": "CO_Ruedi.csv",
    "Sanchez": "CO_Sanchez.csv",
    "Santa Maria": "CO_Santa_Maria.csv",
    "Shadow Mountain": "CO_Shadow_Mountain.csv",
    "Spinney Mountain": "CO_Spinney_Mountain.csv",
    "Stagecoach": "CO_Stagecoach.csv",
    "Standley": "CO_Standley.csv",
    "Terrace": "CO_Terrace.csv",
    "Trinidad Lake": "CO_Trinidad_Lake.csv",
    "Turquoise Lake": "CO_Turquoise_Lake.csv",
    "Twin Lakes": "CO_Twin_Lakes.csv",
    "Union": "CO_Union.csv",
    "Williams Fork": "CO_Williams_Fork.csv",
    "Windsor": "CO_Windsor.csv",
    "Wolford Mountain": "CO_Wolford_Mountain.csv",
    "Bear Lake": "ID_Bear_Lake.csv",
    "Blackfoot": "ID_Blackfoot.csv",
    "Brownlee": "ID_Brownlee.csv",
    "Dworshak": "ID_Dworshak.csv",
    "Lake Coeur d'Alene": "ID_Lake_Coeur_d_Alene.csv",
    "Lake Pend Oreille": "ID_Lake_Pend_Oreille.csv",
    "Magic": "ID_Magic.csv",
    "Montpelier": "ID_Montpelier.csv",
    "Oakley": "ID_Oakley.csv",
    "Priest Lake": "ID_Priest_Lake.csv",
    "Salmon Falls": "ID_Salmon_Falls.csv",
    "Ackley Lake": "MT_Ackley_Lake.csv",
    "Ashley Lake": "MT_Ashley_Lake.csv",
    "Bair": "MT_Bair.csv",
    "Bighorn Lake": "MT_Bighorn_Lake.csv",
    "Canyon Ferry Lake": "MT_Canyon_Ferry_Lake.csv",
    "Clark Canyon": "MT_Clark_Canyon.csv",
    "Cooney": "MT_Cooney.csv",
    "Deadman's Basin": "MT_Deadman_s_Basin.csv",
    "East Fork Rock Creek": "MT_East_Fork_Rock_Creek.csv",
    "Ennis Lake": "MT_Ennis_Lake.csv",
    "Fort Peck Lake": "MT_Fort_Peck_Lake.csv",
    "Fresno": "MT_Fresno.csv",
    "Gibson": "MT_Gibson.csv",
    "Hauser Lake & Lake Helena": "MT_Hauser_Lake_&_Lake_Helena.csv",
    "Hebgen Lake": "MT_Hebgen_Lake.csv",
    "Holter Lake": "MT_Holter_Lake.csv",
    "Lake Elwell (Tiber)": "MT_Lake_Elwell_(Tiber).csv",
    "Lake Koocanusa": "MT_Lake_Koocanusa.csv",
    "Lake Sherburne": "MT_Lake_Sherburne.csv",
    "Lima": "MT_Lima.csv",
    "Lower Two Medicine Lake": "MT_Lower_Two_Medicine_Lake.csv",
    "Martinsdale": "MT_Martinsdale.csv",
    "Middle Creek": "MT_Middle_Creek.csv",
    "Nelson": "MT_Nelson.csv",
    "Nevada Creek": "MT_Nevada_Creek.csv",
    "Nilan": "MT_Nilan.csv",
    "Noxon Rapids": "MT_Noxon_Rapids.csv",
    "Painted Rocks Lake": "MT_Painted_Rocks_Lake.csv",
    "Pishkun": "MT_Pishkun.csv",
    "Ruby River": "MT_Ruby_River.csv",
    "Swift": "MT_Swift.csv",
    "Tongue River": "MT_Tongue_River.csv",
    "Abiquiu": "NM_Abiquiu.csv",
    "Bluewater Lake": "NM_Bluewater_Lake.csv",
    "Brantley Lake": "NM_Brantley_Lake.csv",
    "Cochiti Lake": "NM_Cochiti_Lake.csv",
    "Conchas Lake": "NM_Conchas_Lake.csv",
    "Costilla": "NM_Costilla.csv",
    "Eagle Nest Lake": "NM_Eagle_Nest_Lake.csv",
    "El Vado": "NM_El_Vado.csv",
    "Heron": "NM_Heron.csv",
    "Lake Avalon": "NM_Lake_Avalon.csv",
    "Lahontan": "NV_Lahontan.csv",
    "Rye Patch": "NV_Rye_Patch.csv",
    "Applegate": "OR_Applegate.csv",
    "Blue River": "OR_Blue_River.csv",
    "Cottage Grove": "OR_Cottage_Grove.csv",
    "Cottonwood": "OR_Cottonwood.csv",
    "Cougar": "OR_Cougar.csv",
    "Detroit": "OR_Detroit.csv",
    "Dorena": "OR_Dorena.csv",
    "Fall Creek": "OR_Fall_Creek.csv",
    "Fern Ridge": "OR_Fern_Ridge.csv",
    "Foster": "OR_Foster.csv",
    "Lost Creek Res": "OR_Lost_Creek_Res.csv",
    "Wallowa Lake": "OR_Wallowa_Lake.csv",
    "Willow Creek": "OR_Willow_Creek.csv",
    "Wolf Creek": "OR_Wolf_Creek.csv",
    "Big Sand Wash": "UT_Big_Sand_Wash.csv",
    "Cleveland Lake": "UT_Cleveland_Lake.csv",
    "Grantsville": "UT_Grantsville.csv",
    "Gunlock": "UT_Gunlock.csv",
    "Gunnison": "UT_Gunnison.csv",
    "Ken's Lake": "UT_Ken_s_Lake.csv",
    "Kolob": "UT_Kolob.csv",
    "Lower Enterprise": "UT_Lower_Enterprise.csv",
    "Miller Flat": "UT_Miller_Flat.csv",
    "Millsite": "UT_Millsite.csv",
    "Minersville": "UT_Minersville.csv",
    "Otter Creek": "UT_Otter_Creek.csv",
    "Panguitch Lake": "UT_Panguitch_Lake.csv",
    "Piute": "UT_Piute.csv",
    "Porcupine": "UT_Porcupine.csv",
    "Quail Creek": "UT_Quail_Creek.csv",
    "Sand Hollow": "UT_Sand_Hollow.csv",
    "Sevier Bridge": "UT_Sevier_Bridge.csv",
    "Smith and Morehouse": "UT_Smith_and_Morehouse.csv",
    "Upper Enterprise": "UT_Upper_Enterprise.csv",
    "Utah Lake": "UT_Utah_Lake.csv",
    "Willard Bay": "UT_Willard_Bay.csv",
    "Woodruff Creek": "UT_Woodruff_Creek.csv",
    "Bumping Lake": "WA_Bumping_Lake.csv",
    "Cle Elum": "WA_Cle_Elum.csv",
    "Conconully": "WA_Conconully.csv",
    "Diablo": "WA_Diablo.csv",
    "Kachess": "WA_Kachess.csv",
    "Keechelus": "WA_Keechelus.csv",
    "Lake Chelan": "WA_Lake_Chelan.csv",
    "Rimrock": "WA_Rimrock.csv",
    "Ross": "WA_Ross.csv",
    "Alcova": "WY_Alcova.csv",
    "Boysen": "WY_Boysen.csv",
    "Buffalo Bill": "WY_Buffalo_Bill.csv",
    "Bull Lake": "WY_Bull_Lake.csv",
    "Glendo": "WY_Glendo.csv",
    "Guernsey": "WY_Guernsey.csv",
    "High Savery": "WY_High_Savery.csv",
    "Keyhole": "WY_Keyhole.csv",
    "Pathfinder": "WY_Pathfinder.csv",
    "Pilot Butte": "WY_Pilot_Butte.csv",
    "Seminoe": "WY_Seminoe.csv",
    "Viva Naughton": "WY_Viva_Naughton.csv",
    "Wheatland #2": "WY_Wheatland__2.csv",
    "Woodruff Narrows": "WY_Woodruff_Narrows.csv"
  }
}

export { reservoirs };



// WEBPACK FOOTER //
// ./src/components/utilities/stations.js